var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h2',[_vm._v("Rachio Sprinkler Mashup with DarkSky Weather Actuals")]),_c('GrachioDisplay',{attrs:{"grachio":_vm.grachio}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }